import TemplateView from "../TemplateView";
import $ from 'jquery'

export class Moire extends TemplateView {
    static getInstance() {
        return getInstance()
    }

    templateHtml() {
        return "<div class='components_moireContainer'/>"
    }
}

let instance = null
const getInstance = () => {
    if (!instance) {
        instance = new Moire().init($("body"))
    }
    return instance
}


// WEBPACK FOOTER //
// ./web/js/components/Moire.js